import Loader from '@/components/common/loader'
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Fragment, useMemo } from 'react'
import OverviewDriverTableRowDesktop from './overview-driver-table-row-desktop'
import OverviewDriverTableRowMobile from './overview-driver-table-row-mobile'

export default function OverviewDriversTable({
  attendees,
  isLoading,
  setValue,
  isManagerSide = true,
  isSingleEvent = false,
  isEventPage = false,
}) {
  const showTeams = useMemo(
    () => (attendees ? attendees.some((r) => r.team) : false),
    [attendees],
  )

  const showSplits = useMemo(
    () => (attendees ? attendees.some((r) => r.split) : false),
    [attendees],
  )

  const showCarClasses = useMemo(
    () => (attendees ? attendees.some((r) => r.carClass) : false),
    [attendees],
  )

  return (
    <Table>
      <TableHeader>
        <TableRow isHeader>
          <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
            Driver
          </TableCell>

          {isManagerSide && (
            <Fragment>
              <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
                Applied
              </TableCell>

              <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
                Status
              </TableCell>
            </Fragment>
          )}

          {showTeams && (
            <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
              Team
            </TableCell>
          )}

          {showCarClasses && (
            <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
              Car Class
            </TableCell>
          )}

          {showSplits && (
            <TableCell className="semibold-caps hidden text-left text-footer text-neutral-blue-500 md:table-cell">
              Tier / Split
            </TableCell>
          )}

          <TableCell />
        </TableRow>
      </TableHeader>

      <TableBody className="min-h-[700px]">
        {isLoading ? (
          <TableRow isHeader>
            <TableCell colSpan={5} className="py-4">
              <Loader size="lg" className="mx-auto" />
            </TableCell>
          </TableRow>
        ) : attendees.length === 0 ? (
          <TableRow>
            <TableCell colSpan={5} className="text-medium py-4 text-center">
              This {isSingleEvent || isEventPage ? 'event' : 'championship'} has
              no registered drivers.
            </TableCell>
          </TableRow>
        ) : (
          attendees.map((attendee, index) => (
            <Fragment key={`driver-${attendee.userId}-${index}`}>
              <TableRow className="mb-5 hidden transition-colors hover:bg-neutral-blue-800 md:table-row">
                <OverviewDriverTableRowDesktop
                  attendee={attendee}
                  setValue={setValue}
                  showTeams={showTeams}
                  showCarClasses={showCarClasses}
                  showSplits={showSplits}
                  isManagerSide={isManagerSide}
                />
              </TableRow>

              <TableRow className="mb-5 flex items-center justify-between rounded-sm border border-neutral-blue-700 px-4 py-2 md:hidden">
                <OverviewDriverTableRowMobile
                  attendee={attendee}
                  setValue={setValue}
                  showTeams={showTeams}
                  showCarClasses={showCarClasses}
                  showSplits={showSplits}
                  isManagerSide={isManagerSide}
                />
              </TableRow>
            </Fragment>
          ))
        )}
      </TableBody>
    </Table>
  )
}
